import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import * as API from "../Endpoints/Endpoints";

const ChakraForm = () => {
  const [allData, setAllData] = useState([]);
  const [uniqueThemes, setUniqueThemes] = useState([]);
  const [selectedTheme, setSelectedTheme] = useState('');
  const [chariotTheme, setChariotTheme] = useState('');
  const [chariotName, setChariotName] = useState('');
  const [chariotNames, setChariotNames] = useState([]);
  const [chariotData, setChariotData] = useState([]);
  const [chariotInfo, setChariotInfo] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [spokeRes, bladeRes] = await Promise.all([
          axios.get(API.GET_SPOKE_API),
          axios.get(API.GET_BLADE_API),
        ]);

        const combinedData = [...spokeRes.data, ...bladeRes.data];
        setAllData(combinedData);

        const themes = new Set(combinedData.map(item => item.theme));
        setUniqueThemes([...themes]);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchChariotNames = async () => {
      try {
        const [globalRes, aichariotRes] = await Promise.all([
          axios.get(API.GET_GLOBAL_ETHICS_API),
          axios.get(API.GET_AI_CHARIOT_API),
        ]);
  
        const combinedData = [...globalRes.data, ...aichariotRes.data];
        setChariotData(combinedData); // 👈 save the full data
  
        const names = new Set(combinedData.map(item => item.chariotname));
        setChariotNames([...names]);
      } catch (err) {
        console.error("Error fetching chariot names:", err);
      }
    };
  
    fetchChariotNames();
  }, []);  

  useEffect(() => {
    if (!chariotName || chariotData.length === 0) {
      setChariotTheme('');
      setChariotInfo(null);
      return;
    }
  
    const match = chariotData.find(item => item.chariotname === chariotName);
    if (match) {
      setChariotTheme(match.theme);
      setChariotInfo(match);
    } else {
      setChariotTheme('');
      setChariotInfo(null);
    }
  }, [chariotName, chariotData]);   

  const handlePlayGame = () => {
    if (selectedTheme) {
      const filteredData = allData.filter(item => item.theme === selectedTheme);
      navigate('/allchakra', { state: { theme: selectedTheme, data: filteredData } });
    } else if (chariotName) {
      const filteredChariotData = chariotData.filter(item => item.chariotname === chariotName);
      navigate('/chariotgame', { state: { chariotName: chariotName, data: filteredChariotData } });
    } else {
      alert('Please select a Game Theme or Chariot Name to play!');
    }
  };  

  return (
    <div className="min-h-screen flex flex-col items-center bg-[#B5B5B5] text-black px-4 py-10">
      
      {/* Play Game Button */}
      <button
        onClick={handlePlayGame}
        className="mb-6 bg-[#e64a32] text-white font-semibold px-6 py-2 rounded shadow-lg"
      >
        Play Game
      </button>

      {/* Two-column layout */}
      <div className="flex flex-col md:flex-row gap-10 w-full max-w-5xl">

        {/* Left Block */}
        <div className="flex-1 min-h-[480px] bg-white p-6 rounded-xl shadow-lg space-y-6 flex flex-col">

          {/* Theme Dropdown */}
          <div>
            <label className="block text-md font-semibold mb-1">Game Theme</label>
            <select
              value={selectedTheme}
              onChange={(e) => setSelectedTheme(e.target.value)}
              className="w-full px-4 py-2 bg-gray-200 text-black rounded"
            >
              <option value="">Select a Theme</option>
              {uniqueThemes.map((theme, idx) => (
                <option key={idx} value={theme}>{theme}</option>
              ))}
            </select>
          </div>

          {/* Heading */}
          <h2 className="text-xl font-bold mt-2">Number of Questions</h2>

          {/* Chakra Levels */}
          <div className="space-y-6">
            <div className="flex justify-between items-center bg-gray-200 px-4 py-2 rounded">
              <span>Vajra Chakra</span>
              <div className="w-8 h-8 flex items-center justify-center bg-blue-600 text-white rounded shadow">1</div>
            </div>
            <div className="flex justify-between items-center bg-gray-200 px-4 py-2 rounded">
              <span>Ashok Chakra</span>
              <div className="w-8 h-8 flex items-center justify-center bg-green-600 text-white rounded shadow">2</div>
            </div>
            <div className="flex justify-between items-center bg-gray-200 px-4 py-2 rounded">
              <span>Sudarshan Chakra</span>
              <div className="w-8 h-8 flex items-center justify-center bg-yellow-500 text-black rounded shadow">7</div>
            </div>
          </div>
        </div>

        {/* Right Block */}
        <div className="flex-1 min-h-[480px] bg-white p-6 rounded-xl shadow-lg space-y-6 flex flex-col justify-between">

          {/* Chariot Name Dropdown */}
          <div className="flex flex-col space-y-1">
          {/* First Dropdown */}
          <div>
            <label className="block text-md font-semibold mb-1">Chariot Name</label>
            <select
              value={chariotName}
              onChange={(e) => setChariotName(e.target.value)}
              className="w-full px-4 py-2 bg-gray-200 text-black rounded"
            >
              <option value="">Select Chariot</option>
              {chariotNames.map((name, idx) => (
                <option key={idx} value={name}>{name}</option>
              ))}
            </select>
          </div>

          {/* Second Dropdown */}
          <div>
            <label className="block text-md font-semibold mb-1">Theme</label>
            <input
              type="text"
              value={chariotTheme}
              readOnly
              className="w-full px-4 py-2 bg-gray-200 text-black rounded"
            />
          </div>
        </div>

        <h2 className="text-xl font-bold mb-1">Number of Questions</h2> 

      <div className="space-y-6">
        <div className="flex justify-between items-center bg-gray-200 px-4 py-2 rounded">
          <span>Jagannath Chariot</span>
          <div className="w-8 h-8 flex items-center justify-center bg-blue-600 text-white rounded shadow">4</div>
        </div>
        <div className="flex justify-between items-center bg-gray-200 px-4 py-2 rounded">
          <span>Balbhadra Chariot</span>
          <div className="w-8 h-8 flex items-center justify-center bg-green-600 text-white rounded shadow">3</div>
        </div>
        <div className="flex justify-between items-center bg-gray-200 px-4 py-2 rounded">
          <span>Subhadra Chariot</span>
          <div className="w-8 h-8 flex items-center justify-center bg-yellow-500 text-black rounded shadow">3</div>
        </div>
      </div>

        </div>
      </div>
    </div>
  );
};

export default ChakraForm;
